module.exports = __webpack_public_path__ + "img/hero.a08d1905.jpg";